function getHiddenPanels() {
  return Array.from(document.querySelectorAll('[role="tabpanel"][hidden]'))
}

function getClosedAccordions() {
  return Array.from(document.querySelectorAll('details:not([open])'))
}

window.addEventListener('beforeprint', () => {
  getHiddenPanels().forEach(panel => panel.removeAttribute('hidden'))
  getClosedAccordions().forEach(details => {
    details.setAttribute('data-print-opened', '')
    details.setAttribute('open', '')
  })
})

window.addEventListener('afterprint', () => {
  document.querySelectorAll('[role="tabpanel"]').forEach((panel, i) => {
    if (i !== 0) panel.setAttribute('hidden', '')
  })
  document.querySelectorAll('details[data-print-opened]').forEach(details => {
    details.removeAttribute('open')
    details.removeAttribute('data-print-opened')
  })
})

document.querySelectorAll('.js-print').forEach(btn => {
  btn.addEventListener('click', () => window.print())
})
